export const getModuleMessages = async (locale: string) => import(`@/modules/settings/locales/${locale}.json`);

export default getModuleMessages;
